import axios, { AxiosResponse } from 'axios';
import { ApiResponse, zps_ms_ea_war } from '../../zps';

export type IAct = {
  destDesisor: boolean;
  destDispacter: boolean;
  destDistributionList: boolean;
  destMonitor: boolean;
};

export type IEventMsg = {
  dateTime: string;
  dateTimeOcc: string;
  devOrder: number;
  devType: number;
  eid: number;
  eventCode: number;
  eventDescription: string;
  eventType: number;
  id: number;
  locid: number;
  msgtype: number;
  value: number;
};

export type IEvent = {
  eventCode: number;
  description: string;
  eventType: number;
  act: IAct;
  actCounter: number;
};
export interface EventMsgsResponse extends ApiResponse {
  events: IEventMsg[];
  totalRows: number;
}

export interface EventsResponse extends ApiResponse {
  events: IEvent[];
  totalRows: number;
  type: string;
}

export const fetchEventMsgsList = (
  controller: AbortController,
  offset: number,
  limit: number,
  totalRows: boolean,
  eid?: number,
  eventCode?: number,
  begin?: string | null,
  end?: string
): Promise<AxiosResponse<EventMsgsResponse>> => {
  const url =
    `${zps_ms_ea_war}/events?offset=${offset}&limit=${limit}&totalRows=${totalRows}` +
    (eid ? `&eid=${eid}` : '') +
    (eventCode ? `&eventCode=${eventCode}` : '') +
    (begin ? `&begin=${begin}` : '') +
    (end ? `&end=${end}` : '');

  return axios.get<EventMsgsResponse>(url, { signal: controller.signal }).catch(err => {
    console.error('Failed to fetch events list:', err);
    throw err;
  });
};

export const fetchEventList = (
  controller: AbortController,
  eventCode?: number
): Promise<AxiosResponse<EventsResponse>> => {
  const url = `${zps_ms_ea_war}/event${eventCode ? `?eventCode=${eventCode}` : ''}`;

  return axios.get<EventsResponse>(url, { signal: controller.signal }).catch(err => {
    console.error('Failed to fetch helpdesk event management list:', err);
    throw err;
  });
};

export const addEvent = (controller: AbortController, eventCode?: number): Promise<AxiosResponse<EventsResponse>> => {
  const url = `${zps_ms_ea_war}/event${eventCode ? `?eventCode=${eventCode}` : ''}`;

  return axios.post<EventsResponse>(url, {}, { signal: controller.signal }).catch(err => {
    console.error('Failed to add helpdesk-managed event:', err);
    throw err;
  });
};

export const updateEvent = (
  controller: AbortController,
  eventCode?: number
): Promise<AxiosResponse<EventsResponse>> => {
  const url = `${zps_ms_ea_war}/event${eventCode ? `?eventCode=${eventCode}` : ''}`;

  return axios.put<EventsResponse>(url, {}, { signal: controller.signal }).catch(err => {
    console.error('Failed to update helpdesk-managed event:', err);
    throw err;
  });
};

export const deleteEvent = (
  controller: AbortController,
  eventCode?: number
): Promise<AxiosResponse<EventsResponse>> => {
  const url = `${zps_ms_ea_war}/event${eventCode ? `?eventCode=${eventCode}` : ''}`;

  return axios.delete<EventsResponse>(url, { signal: controller.signal }).catch(err => {
    console.error('Failed to delete helpdesk-managed event:', err);
    throw err;
  });
};
